let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fnm9b"), load("h8wf0")]).then(() => parcelRequire('aDU3N'));